import { useState } from "react";

const BRAND = "#FF6B35";

interface Props {
  item: {
    id: number;
    item_name: string;
    book_time: string; // 服务时间
    name: string; // 服务人员
    form_content?: Array<{ title: string; value: string }>; // 评价详情（键值对数组）
    add_time?: string;
  };
}

/**
 * 原版 comment-item.vue 行为：
 * - 显示项目名称（可折叠）
 * - 显示服务时间、服务人员
 * - 展开后显示 form_content 键值对列表 + 评价时间
 */
export function CommentItem({ item }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="mt-[15px] px-[15px] box-border bg-white rounded-[10px]">
      <div className="py-[15px] flex flex-col" style={{ rowGap: 10 }}>
        {/* 标题行 + 展开/收起 */}
        <div className="flex justify-between items-center">
          <span className="text-sm font-bold text-gray-900">{item.item_name}</span>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="flex items-center gap-1 cursor-pointer active:opacity-70"
            style={{ color: BRAND }}
          >
            <span className="text-xs">{isOpen ? "收起" : "展开"}</span>
            <i
              className={`ri-arrow-down-s-fill ${isOpen ? "" : ""}`}
              style={{
                fontSize: 24,
                color: BRAND,
                transform: isOpen ? "rotate(180deg)" : undefined,
                transition: "transform 0.2s",
              }}
            />
          </button>
        </div>

        {/* 基本信息 */}
        <div className="flex items-center">
          <span className="text-sm text-gray-500">服务时间：</span>
          <span>{item.book_time}</span>
        </div>
        <div className="flex items-center">
          <span className="text-sm text-gray-500">服务人员：</span>
          <span>{item.name}</span>
        </div>

        {/* 展开内容 — form_content 键值对列表 */}
        {isOpen && (
          <div className="border-t border-t-gray-200 border-l-0 border-r-0 border-b-0 py-[15px] text-sm flex flex-col" style={{ gap: 10 }}>
            {/* 遍历 form_content 数组，每项显示 title: value */}
            {(item.form_content || []).map((val, key) => (
              <div key={key} className="flex items-center">
                <span className="text-gray-500">{val.title}：</span>
                <span>{val.value || "无"}</span>
              </div>
            ))}

            {/* 评价时间 */}
            <div className="flex items-center">
              <span className="text-gray-500">评价时间：</span>
              <span>{item.add_time || ""}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
